import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Image from '../../components/ContentfulImage';
import Placeholder from '../../components/Placeholder';
import Markdown from '../Markdown';

import {
  Section,
  SectionInner,
  BenefitsContainer,
  BenefitsText,
  ImageWrapper,
  Title,
  BenefitTitle,
  Text,
} from './ProductBenefits.style';

const ProductBenefits = ({ benefits, extended, copy }) => (
  <Section extended={extended}>
    <SectionInner>
      <Title>{copy.benefits || <Placeholder h="20px" w="100px" />}</Title>

      <BenefitsContainer>
        <BenefitsText>
          {benefits
            ? benefits.map(({ name, description }) => (
                <div key={name}>
                  <BenefitTitle>{name}</BenefitTitle>
                  <Markdown src={description} Component={Text} />
                </div>
              ))
            : [1, 2, 3].map(key => (
                <div key={key}>
                  <BenefitTitle>
                    <Placeholder h="unset" w="100%" pb="10%" />
                  </BenefitTitle>
                  <Text>
                    <Placeholder h="unset" w="100%" pb="5%" />
                  </Text>
                </div>
              ))}
        </BenefitsText>

        <ImageWrapper>
          {benefits ? (
            benefits[0].image && <Image src={benefits[0].image} options={{ w: '100%', size: 400 }} />
          ) : (
            <Placeholder h="unset" w="100%" pb="70%" />
          )}
        </ImageWrapper>
      </BenefitsContainer>
    </SectionInner>
  </Section>
);

ProductBenefits.defaultProps = {
  copy: {},
  benefits: undefined,
  extended: false,
};

ProductBenefits.propTypes = {
  copy: PropTypes.shape(),
  benefits: PropTypes.arrayOf(PropTypes.shape({})),
  extended: PropTypes.bool,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyProductPage,
});

export default connect(mapState)(ProductBenefits);



// WEBPACK FOOTER //
// ./src/components/ProductBenefits/ProductBenefits.js